module.exports = __webpack_public_path__ + "media/src/images/icons/clocks/default-3b13efc033639ac9265463b9ab23a25e.svg";